function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
var SvgIconUntie = function SvgIconUntie(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13.0996 12.4141L11.3636 10.678",
    stroke: "currentColor",
    strokeWidth: 0.866441,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6855 8.83203H12.2304",
    stroke: "currentColor",
    strokeWidth: 0.866441,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.43359 14V11.5449",
    stroke: "currentColor",
    strokeWidth: 0.866441,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.58789 2.58789L4.32393 4.32393",
    stroke: "currentColor",
    strokeWidth: 0.866441,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 6.01172L3.45513 6.01172",
    stroke: "currentColor",
    strokeWidth: 0.866441,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.0957 1L6.0957 3.45513",
    stroke: "currentColor",
    strokeWidth: 0.866441,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.76222 7.23828L2.32568 9.67483C0.0657241 11.9347 3.57433 15.3398 5.78253 13.1317L8.20376 10.7104",
    stroke: "currentColor",
    strokeWidth: 0.866441,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7632 7.96875L13.1997 5.5322C15.4597 3.27232 11.9511 -0.132756 9.74286 2.07535L7.32163 4.49659",
    stroke: "currentColor",
    strokeWidth: 0.866441,
    strokeLinecap: "round"
  }));
};
export default SvgIconUntie;